import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "medexpert-directories",
  "use": "medexpert-directories-usage",
  "viewBox": "0 0 12 16",
  "content": "<symbol viewBox=\"0 0 12 16\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"medexpert-directories\">\r\n<path d=\"M2 0C0.895 0 0 0.895 0 2V14C0 15.105 0.895 16 2 16H10C11.105 16 12 15.105 12 14V3.5H7.529C6.883 3.5 6.278 3.188 5.902 2.663L4 0L2 0Z\" />\r\n<path opacity=\"0.2\" d=\"M11.937 1.5C11.715 0.637 10.932 0 10 0H6.45801L7.53001 1.5H11.937Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol